import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const insightsPortalOfferIngestionAccessControl: DomainAccessControlConfig = [
  {
    permissions: Permission.Performance,
    featureToggles: [FeatureToggle.InsightsPortalOfferIngestionDashboard],
  },
]
